import { FC, ReactNode } from 'react'
import { ClusterAvatar, ClusterAvatarType } from './Avatar'
import {
  ClosestClusterTitle,
  ClosestClusterTitleType,
} from './ClosestClusterTitle'
import { ClusterMap, ClusterMapType } from './Map'
import { ClusterOption, ClusterOptionType } from './Option'

const Cluster: FC &
  ClusterAvatarType &
  ClusterOptionType &
  ClusterMapType &
  ClosestClusterTitleType = (): ReactNode => <></>

Cluster.Avatar = ClusterAvatar
Cluster.Option = ClusterOption
Cluster.Map = ClusterMap
Cluster.ClosestClusterTitle = ClosestClusterTitle

export default Cluster
